// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arq-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f6f7;
}

.arq-topbar-actions {
  display: flex;
  align-items: center;
}

.arq-container {
  padding: 24px 32px;
  flex: 1 1;
}

.arq-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.arq-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

.arq-banner {
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
}

.arq-banner-error {
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.arq-empty {
  padding: 40px;
  text-align: center;
  color: #6b7280;
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.arq-table-wrapper {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow-x: auto;
}

.arq-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.arq-table th,
.arq-table td {
  text-align: left;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}

.arq-table th {
  color: #6b7280;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background-color: #f8f9fa;
}

.arq-table tbody tr:last-child td {
  border-bottom: none;
}

.arq-row-decided {
  opacity: 0.5;
}

.arq-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.arq-tag-internal {
  background-color: #e8f4fb;
  color: #0369a1;
}

.arq-tag-external {
  background-color: #f3e8ff;
  color: #7e22ce;
}

.arq-actions {
  display: flex;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/AccessRequestQueue/AccessRequestQueue.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV","sourcesContent":[".arq-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: #f5f6f7;\n}\n\n.arq-topbar-actions {\n  display: flex;\n  align-items: center;\n}\n\n.arq-container {\n  padding: 24px 32px;\n  flex: 1;\n}\n\n.arq-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.arq-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.arq-banner {\n  padding: 10px 14px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n.arq-banner-error {\n  background-color: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.arq-empty {\n  padding: 40px;\n  text-align: center;\n  color: #6b7280;\n  background-color: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n}\n\n.arq-table-wrapper {\n  background-color: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  overflow-x: auto;\n}\n\n.arq-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.arq-table th,\n.arq-table td {\n  text-align: left;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e5e7eb;\n  white-space: nowrap;\n}\n\n.arq-table th {\n  color: #6b7280;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background-color: #f8f9fa;\n}\n\n.arq-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.arq-row-decided {\n  opacity: 0.5;\n}\n\n.arq-tag {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.arq-tag-internal {\n  background-color: #e8f4fb;\n  color: #0369a1;\n}\n\n.arq-tag-external {\n  background-color: #f3e8ff;\n  color: #7e22ce;\n}\n\n.arq-actions {\n  display: flex;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
